import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { DataProvider } from './store/DataContext';
import { Login } from './pages/Login';
import { DashboardLayout } from './components/layout/DashboardLayout';
import { DashboardRouter } from './pages/DashboardRouter';
import { PatientFiles } from './pages/admin/PatientFiles';
import { StaffManagement } from './pages/admin/StaffManagement';
import { ActivityLog } from './pages/admin/ActivityLog';
import { MaternityFiles } from './pages/maternity/MaternityFiles';
import { BillingModule } from './pages/billing/BillingModule';
import { PharmacyModule } from './pages/pharmacy/PharmacyModule';
export function App() {
  return <DataProvider data-id="element-0" data-mp="2wjgq7g0cxrfd">
      <BrowserRouter data-id="element-1" data-mp="2wiyuqllirh8i">
        <Routes data-id="element-2" data-mp="2wip5j08ate3v">
          <Route path="/login" element={<Login data-id="element-4" data-mp="28tw62tsgwo4i" />} data-id="element-3" data-mp="2wi5mthatqlos" />
          <Route path="/dashboard" element={<DashboardLayout data-id="element-6" data-mp="28sl0cofgp6ar" />} data-id="element-5" data-mp="28te2fc3h77mk">
            <Route index element={<DashboardRouter data-id="element-8" data-mp="23w4drynwuzzs" />} data-id="element-7" data-mp="23vkvggucm9l8" />
            <Route path="patients" element={<PatientFiles data-id="element-10" data-mp="3ijxqiu0iq6lh" />} data-id="element-9" data-mp="23v2r0wxj8p28" />
            <Route path="maternity" element={<MaternityFiles data-id="element-12" data-mp="3ijftvw9y1qd1" />} data-id="element-11" data-mp="3ikqz80j1f669" />
            <Route path="billing" element={<BillingModule data-id="element-14" data-mp="3mkrc3gqhn9b7" />} data-id="element-13" data-mp="3mlj8gtrwtb2j" />
            <Route path="pharmacy" element={<PharmacyModule data-id="element-16" data-mp="3rc9f0ac2njyt" />} data-id="element-15" data-mp="3mjzpgvevclx2" />
            <Route path="staff" element={<StaffManagement data-id="element-18" data-mp="3rcswjpxt86cb" />} data-id="element-17" data-mp="3rbznujfaj6rj" />
            <Route path="activity-log" element={<ActivityLog data-id="element-20" data-mp="680frswe88f" />} data-id="element-19" data-mp="5yjsutqtdfe" />
          </Route>
          <Route path="/" element={<Navigate to="/dashboard" replace data-id="element-22" data-mp="2zld0z6e9z99y" />} data-id="element-21" data-mp="82jf0klzq9v" />
        </Routes>
      </BrowserRouter>
    </DataProvider>;
}